import type { RouteObject } from "react-router";

/** `/alerts` — rules, the firing log and the notification settings. */
export const alertsRoutes: RouteObject[] = [
  { path: "alerts", lazy: async () => ({ Component: (await import("./AlertsView")).default }) },
];
